import { render, staticRenderFns } from "./accountRoleTips.vue?vue&type=template&id=73796b91"
import script from "./accountRoleTips.vue?vue&type=script&lang=js"
export * from "./accountRoleTips.vue?vue&type=script&lang=js"
import style0 from "./accountRoleTips.vue?vue&type=style&index=0&id=73796b91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports